export default __webpack_public_path__ + "static/Average May temp 2015-bd7dfd78fa54aa8cac3c42320a538bea.png";